import { render } from "./HomeModule.vue?vue&type=template&id=65c7cd09"
import script from "./HomeModule.vue?vue&type=script&lang=ts"
export * from "./HomeModule.vue?vue&type=script&lang=ts"

import "../../assets/scss/modules/home.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script